module.exports = __webpack_public_path__ + "img/icon-payment-creditcard-green@3x.150168a2.png";